export function DateConvert(date) {
  if (!date) {
    return null;
  }
  date = new Date(date);
  let newDate =
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    date.getFullYear();
  return newDate;
}
